import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import MediaQuery from 'react-responsive';
import { Navbar, Nav, Container, Row, Col, ListGroup } from 'react-bootstrap';
import Sticky from 'react-stickynode';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import Wrapper from '../wrapper/Wrapper';
import { mobileAppUtil } from '../../util'; // Type defintitions

import * as TYPES from '../../types';
import { HorizontalMenu } from "./HorizontalMenu";
import { useHistory } from 'react-router-dom'; // JSS
// import { Link } from '@sitecore-jss/sitecore-jss-react';

import { SitecoreLink } from '../link/Link'; //ga tracker

import gaTracker from '../../util/ga-analytics/gaTracker';

var EatNav = function EatNav(_ref) {
  var _document$getElementB, _document$getElementB2, _document$getElementB3;

  var _ref$navLinks = _ref.navLinks,
      navLinks = _ref$navLinks === void 0 ? [] : _ref$navLinks,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? {
    background: "white",
    padding: "small"
  } : _ref$layout,
      changeCategory = _ref.changeCategory,
      currentCategory = _ref.currentCategory;

  var _useState = useState(currentCategory),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isSticky = _useState4[0],
      setSticky = _useState4[1];

  var setValues = function setValues(value) {
    if (typeof value === 'string' && value !== "") {
      value = JSON.parse(value);
      console.log(value, "values");
    }

    if (value) {
      var normalizedName = value.id.toLowerCase();
      value.normalized = normalizedName;
      setActive(value);
      changeCategory(value);
    }

    return;
  };

  var handleCategory = function handleCategory(navLinks, active) {
    var _window$location$path;

    var category = (_window$location$path = window.location.pathname.split("/")[2]) === null || _window$location$path === void 0 ? void 0 : _window$location$path.toLowerCase(); //if no category defined, set that as so

    if (category === undefined) {
      setActive({
        featureName: "All",
        href: "/menu",
        id: "all",
        text: "All",
        title: "All"
      });
      changeCategory("");
      return;
    }

    var names = navLinks.map(function (nav) {
      return nav.value.id;
    });
    var indexOfCategory = names.indexOf(category);

    if (indexOfCategory !== -1) {
      return setValues(navLinks[indexOfCategory].value);
    } //return saved category
    else {
        return setValues(active);
      }
  };

  var history = useHistory();
  useEffect(function () {// if(active?.id){
    //     const activeElement = document.getElementById(`cb-menu__list container`)
    //     window.setTimeout(() => activeElement?.scrollIntoView({behavior: "smooth", block: "center",inline: "nearest"}), 200)
    // }
  }, [active === null || active === void 0 ? void 0 : active.id]);
  useEffect(function () {
    handleCategory(navLinks, active);
  }, [navLinks]);
  useEffect(function () {}, [isSticky]);

  var ribbonClick = function ribbonClick(title, id) {
    var data = {
      gtm: {
        uniqueEventId: 83,
        elementTarget: title,
        elementText: title,
        elementId: id
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  var goToLink = function goToLink(link, usePushState) {
    if (mobileAppUtil.isMobileApp()) {
      history.push(link);
    } else {
      if (usePushState) {
        window.history.pushState({}, '', link);
      } else {
        window.location = link;
      }
    }
  };

  var isCater = window.location.pathname.includes('/cater');
  var isEat = window.location.pathname.includes('/menu'); // const paddingTop = (mobileAppUtil.isiOS() && isSticky) ? '40px' : '0px'

  var paddingTop = mobileAppUtil.isiOS() && isSticky ? '0px' : '0px';

  var handleStateChange = function handleStateChange(statusobj) {
    var status = statusobj.status; // if(mobileAppUtil.isiOS())
    // if(status == 2 || status == 'STATUS_FIXED'){
    //   setSticky(true)
    // }else{
    //   setSticky(false)
    // }
  };

  var activeItemChangedCallback = function activeItemChangedCallback(allItems, selectedItemKey) {
    var items = allItems === null || allItems === void 0 ? void 0 : allItems.filter(function (x) {
      var _x$value;

      return (x === null || x === void 0 ? void 0 : (_x$value = x.value) === null || _x$value === void 0 ? void 0 : _x$value.id) == selectedItemKey;
    });

    if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
      var _items$, _items$$value, _items$2;

      var pathName = window.location.pathname.split('/');
      goToLink((_items$ = items[0]) === null || _items$ === void 0 ? void 0 : (_items$$value = _items$.value) === null || _items$$value === void 0 ? void 0 : _items$$value.href, true);

      if (((_items$2 = items[0]) === null || _items$2 === void 0 ? void 0 : _items$2.value.text) == 'All') {
        var _items$3, _items$3$value;

        goToLink((_items$3 = items[0]) === null || _items$3 === void 0 ? void 0 : (_items$3$value = _items$3.value) === null || _items$3$value === void 0 ? void 0 : _items$3$value.href, false);
      }

      if (pathName.length === 2) {
        var _items$4, _items$4$value;

        goToLink((_items$4 = items[0]) === null || _items$4 === void 0 ? void 0 : (_items$4$value = _items$4.value) === null || _items$4$value === void 0 ? void 0 : _items$4$value.href.replace('/sitecore/content/crackerbarrel/brandsite/home/', ''), false);
      } else {
        var _items$5, _items$6;

        setValues((_items$5 = items[0]) === null || _items$5 === void 0 ? void 0 : _items$5.value);
        changeCategory((_items$6 = items[0]) === null || _items$6 === void 0 ? void 0 : _items$6.value);
      }
    }
  };

  var allLink = {
    path: "/menu",
    value: {
      featureName: "All",
      href: "/menu",
      id: "all",
      text: "All",
      title: "All"
    }
  };

  if (isCater) {
    allLink.value.href = "/catering";
    allLink.path = "/catering";
  }

  var navigationLinks = [allLink].concat(navLinks);
  var tempProps = {
    paddingTop: paddingTop,
    navLinks: navigationLinks,
    activeItemChangedCallback: activeItemChangedCallback,
    activeItem: active === null || active === void 0 ? void 0 : active.id,
    isRetail: false
  };
  var top = ((_document$getElementB = document.getElementById('mobileHeader')) === null || _document$getElementB === void 0 ? void 0 : (_document$getElementB2 = _document$getElementB.style) === null || _document$getElementB2 === void 0 ? void 0 : (_document$getElementB3 = _document$getElementB2.height) === null || _document$getElementB3 === void 0 ? void 0 : _document$getElementB3.replace('px', '')) || 80;
  return /*#__PURE__*/React.createElement(React.Fragment, null, mobileAppUtil.isMobileApp() ? /*#__PURE__*/React.createElement(Sticky, {
    enabled: true,
    top: Number(mobileAppUtil.isMobileApp() ? top : 0),
    innerZ: 2,
    onStateChange: handleStateChange
  }, /*#__PURE__*/React.createElement(HorizontalMenu, tempProps)) : /*#__PURE__*/React.createElement(Sticky, {
    enabled: true,
    top: 0,
    innerZ: 2,
    onStateChange: handleStateChange
  }, /*#__PURE__*/React.createElement(HorizontalMenu, tempProps)));
};

export default EatNav;